import React, { useState } from 'react';
import { BottomNavigation, BottomNavigationAction, Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import LanIcon from '@mui/icons-material/Lan';
import StoreIcon from '@mui/icons-material/Store';
import ContactsIcon from '@mui/icons-material/ContactPage';
import CoinIcon from '@mui/icons-material/MonetizationOn';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../../hooks/auth/UserProvider';
import { isNationalEntityUser } from '../../helpers/authorizedUser';
import { useTranslationContext } from '../../hooks/translations/translationsProvider';

const FooterNavigation: React.FC = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate(); // Hook per la navigazione
  const {auth, user} = useUserContext();
  const {t} = useTranslationContext();
  const showBuy = auth.isAuthenticated && isNationalEntityUser(user);
  const authenticatedRoutes = [
    '/home',
    ...(showBuy ? ['/buy'] : []),
    '/withdraw',
    '/user/info',
  ];

  const handleNavigation = (newValue: number) => {
    setValue(newValue);
    const path = authenticatedRoutes[newValue];
    if (path) {
      navigate(path);
    }
  };

  return (
    <Box sx={{ width: '100%', position: 'fixed', bottom: 0 }}>
      {auth.isAuthenticated ?
        <BottomNavigation
            value={value}
            onChange={(event, newValue) => {
                handleNavigation(newValue)
            }}
            showLabels
        >
            <BottomNavigationAction label={t("Home")} icon={<HomeIcon />} disabled={!auth.isAuthenticated} />
            {showBuy && (
            <BottomNavigationAction label={t("Acquista")} icon={<PaymentIcon />} />
            )}
            <BottomNavigationAction label={t("Preleva")} icon={<AccountBalanceWalletIcon />} disabled={!auth.isAuthenticated} />
            <BottomNavigationAction label={t("Profilo")} icon={<PersonIcon />} disabled={!auth.isAuthenticated} />
        </BottomNavigation> :
        <BottomNavigation
            value={value}
            onChange={(event, newValue) => {
                handleNavigation(newValue)
            }}
            showLabels
        >
            {/* <BottomNavigationAction label={t("Home")} icon={<HomeIcon/>}/>
            <BottomNavigationAction label={t("Circuito")} icon={<LanIcon />} />
            <BottomNavigationAction label={t("Mercato")} icon={<StoreIcon />} />
            <BottomNavigationAction label="ASSO" icon={<CoinIcon />} /> */}
        </BottomNavigation>
      }
    </Box>
  );
};

export default FooterNavigation;
